























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Org } from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';
import { getGeneralActionText } from '@/common/HelpTextUtils';

@Component({
	methods: {
		getGeneralActionText,
	},
	components: { InformationRow, TooltipButton },
})
export default class OrgRow extends Vue {
	@Prop({ required: true })
	public org!: Org | null;

	@Prop({ required: false })
	public productOrdwayAttributes?: ProductOrdwayAttributes | null;
}
